module.exports = __webpack_public_path__ + "img/apvs-logo.5ec552dd.png";